module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "loginhead"
  }, [_c('div', {
    staticClass: "headleft"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "headnav"
  }, _vm._l((_vm.navArr), function(item, index) {
    return _c('a', {
      key: index,
      attrs: {
        "href": "#nogo"
      },
      on: {
        "click": function($event) {
          return _vm.tip(item)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0), _vm._v(" "), (_vm.user.id > 0) ? _c('div', {
    staticClass: "headlefticon"
  }, [_c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        path: '/updateinfo'
      }),
      expression: "{path:'/updateinfo'}"
    }],
    staticClass: "headlefticon_name",
    staticStyle: {
      "color": "#fff",
      "display": "flex",
      "flex-direction": "row",
      "align-items": "center",
      "margin-left": "10px",
      "font-size": "16px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.user.name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "headicon"
  }, [_c('div', {
    staticClass: "loginbtn registerbtn",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("退出")])])]) : _c('div', {
    staticClass: "headlefticon"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logoAndname"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "object-fit": "cover"
    },
    attrs: {
      "src": require("@/assets/images/login/pic-logo.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headicon"
  }, [_c('div', {
    staticClass: "loginbtn"
  }, [_vm._v("登录")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headicon"
  }, [_c('div', {
    staticClass: "loginbtn registerbtn"
  }, [_vm._v("注册")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-189c7e1e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/HeadNav.vue
// module id = 1159
// module chunks = 0